import { chain, isEmpty, mapValues } from 'lodash';

import { LocalStorageCompatible } from './local-storage-compatible';
import { isLocalStorageV16, LocalStorageV16 } from './local-storage-v16';
import { upgrade as upgradeFromPrevious } from './local-storage-v16.upgrade';
import { LocalStorageV17 } from './local-storage-v17';

/*
 * NOTE: Create new migration files only when you need to remove or edit existing field. Do not create new migration file for adding new field.
 */
export async function upgrade(raw: LocalStorageCompatible): Promise<LocalStorageV17> {
  const input: LocalStorageV16 = isLocalStorageV16(raw) ? raw : await upgradeFromPrevious(raw);
  const { data } = input;

  const { chartWidgetOptionsByProject, ...rest } = data;

  // Filter out empty chart options.
  // A bug in the previous version caused excessive amounts of empty chart options to be stored,
  // affecting the cost of parsing the local storage.
  const filteredChartWidgetOptionsByProject: LocalStorageV17['data']['chartWidgetOptionsByProject'] =
    mapValues(chartWidgetOptionsByProject, (projectChartOptions) => {
      return chain(projectChartOptions)
        .toPairs()
        .filter(([, chartOptions]) => !isEmpty(chartOptions))
        .fromPairs()
        .value();
    });

  return {
    version: 17,
    data: {
      ...rest,
      chartWidgetOptionsByProject: filteredChartWidgetOptionsByProject,
    },
  };
}
